<div class="hw-box-content">
  <div class="hw-header-wrap">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-6">Admin Setup</div>
          <div class="col-6 text-right">
            <fn-button
              [type]="'info'"
              btnClass="btn-sm btn-round"
              [text]="'Save'"
              (click)="saveData()"
            ></fn-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="hw-content">
    <div class="col-8 offset-2">
      <div class="row">
        <div class="col-12 plumConnectorSetting">
          <form name="altaAdmin" ngForm="altaAdmin" class="form-horizontal">
            <div class="box-content">
              <h4 class="plumConnectorHeading">App Info</h4>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >Application Name</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="appName"
                        [(ngModel)]="objectHash.appName"
                        [dataKey]="'appName'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >Environment ID</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="environmentID"
                        [(ngModel)]="objectHash.environmentID"
                        [dataKey]="'environmentID'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left">
                        Global API Key</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="glbApiKey"
                        [(ngModel)]="objectHash.glbApiKey"
                        [dataKey]="'glbApiKey'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >OffSet Days To Delete</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="offSetDaysToDelete"
                        [(ngModel)]="objectHash.offSetDaysToDelete"
                        [dataKey]="'offSetDaysToDelete'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >To Be UpdateKey Set:</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="toBeUpdateKeySet"
                        [(ngModel)]="objectHash.toBeUpdateKeySet"
                        [dataKey]="'toBeUpdateKeySet'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >OffSet Days To Delete Timer Task</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="offSetToDeleteTimerTask"
                        [(ngModel)]="objectHash.offSetToDeleteTimerTask"
                        [dataKey]="'offSetToDeleteTimerTask'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="control-label text-left"
                    >Enable Delete Old History</label
                  >
                </div>
                <div class="col-8">
                  <fn-switch
                    [(ngModel)]="objectHash.enableDeleteOldHistory"
                    name="enableDeleteOldHistory"
                  ></fn-switch>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="control-label text-left"
                    >Enable Push Notification Feature</label
                  >
                </div>
                <div class="col-8">
                  <fn-switch
                    [(ngModel)]="objectHash.enablePushNotification"
                    name="enablePushNotification"
                  ></fn-switch>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="control-label text-left"
                    >Enable Alert Statistics Feature</label
                  >
                </div>
                <div class="col-8">
                  <fn-switch
                    [(ngModel)]="objectHash.enableStatistics"
                    name="enableStatistics"
                  ></fn-switch>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="control-label text-left"
                    >Is DB Service Down(Testing)</label
                  >
                </div>
                <div class="col-8">
                  <fn-switch
                    [(ngModel)]="objectHash.isDBServiceDown"
                    name="isDBServiceDown"
                  ></fn-switch>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="control-label text-left"
                    >Enable Mail Service</label
                  >
                </div>
                <div class="col-8">
                  <fn-switch
                    [(ngModel)]="objectHash.enableMailService"
                    name="enableMailService"
                  ></fn-switch>
                </div>
              </div>
            </div>
            <div class="box-content">
              <h4 class="plumConnectorHeading">GlobalAssets Info</h4>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >GlobalAssets API Key</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="globalAssetsApiKey"
                        [(ngModel)]="objectHash.globalAssetsApiKey"
                        [dataKey]="'globalAssetsApiKey'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >GlobalAssets URL</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="globalAssetsUrl"
                        [(ngModel)]="objectHash.globalAssetsUrl"
                        [dataKey]="'globalAssetsUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >GlobalAssets Public URL</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="glbAssetsPublicUrl"
                        [(ngModel)]="objectHash.glbAssetsPublicUrl"
                        [dataKey]="'glbAssetsPublicUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-content">
              <h4 class="plumConnectorHeading">SQLTracker Info</h4>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >SQL Tracker Url</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="sqlTrackerUrl"
                        [(ngModel)]="objectHash.sqlTrackerUrl"
                        [dataKey]="'sqlTrackerUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-content">
              <h4 class="plumConnectorHeading">CET Info</h4>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left">CET API Key</label>
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="cetApiKey"
                        [(ngModel)]="objectHash.cetApiKey"
                        [dataKey]="'cetApiKey'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left">CET Url</label>
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="cetUrl"
                        [(ngModel)]="objectHash.cetUrl"
                        [dataKey]="'cetUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-content">
              <h4 class="plumConnectorHeading">HW CET Info</h4>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >HW CET API Key</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="hwCetApiKey"
                        [(ngModel)]="objectHash.hwCetApiKey"
                        [dataKey]="'hwCetApiKey'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left">HW CET URL</label>
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="hwCetUrl"
                        [(ngModel)]="objectHash.hwCetUrl"
                        [dataKey]="'hwCetUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-content">
              <h4 class="plumConnectorHeading">Telegram Info</h4>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >Telegram Url</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="teligramUrl"
                        [(ngModel)]="objectHash.teligramUrl"
                        [dataKey]="'teligramUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >Telegram API key</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="teligramApiKey"
                        [(ngModel)]="objectHash.teligramApiKey"
                        [dataKey]="'teligramApiKey'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="control-label text-left"
                    >Enable Telegram Service</label
                  >
                </div>
                <div class="col-8">
                  <fn-switch
                    [(ngModel)]="objectHash.enabletelegramService"
                    name="enabletelegramService"
                  ></fn-switch>
                </div>
              </div>
            </div>
            <div class="box-content">
              <h4 class="plumConnectorHeading">Mail Server Info</h4>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >MailServerUrl</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="mailServerUrl"
                        [(ngModel)]="objectHash.mailServerUrl"
                        [dataKey]="'mailServerUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >mailServerApiKey</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="mailServerApiKey"
                        [(ngModel)]="objectHash.mailServerApiKey"
                        [dataKey]="'mailServerApiKey'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-content">
              <h4 class="plumConnectorHeading">EDM Info</h4>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >EDM API Key:</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="edmApiKey"
                        [(ngModel)]="objectHash.edmApiKey"
                        [dataKey]="'edmApiKey'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left">EDM Url</label>
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="edmServerUrl"
                        [(ngModel)]="objectHash.edmServerUrl"
                        [dataKey]="'edmServerUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >EDM Agent Api Key</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="edmAgentApiKey"
                        [(ngModel)]="objectHash.edmAgentApiKey"
                        [dataKey]="'edmAgentApiKey'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-content">
              <h4 class="plumConnectorHeading">ATSService Info</h4>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >ATSService API Key</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="atsServiceApiKey"
                        [(ngModel)]="objectHash.atsServiceApiKey"
                        [dataKey]="'atsServiceApiKey'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >ATSService URL</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="atsServiceUrl"
                        [(ngModel)]="objectHash.atsServiceUrl"
                        [dataKey]="'atsServiceUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >ATSService Public URL:</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="atsServicePublicUrl"
                        [(ngModel)]="objectHash.atsServicePublicUrl"
                        [dataKey]="'atsServicePublicUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-content">
              <h4 class="plumConnectorHeading">ATSConsumer Info</h4>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <!-- <div class="col-4">
                                            <label class="control-label text-left">UrlShortner Url</label>
                                        </div>
                                        <div class="col-8">
                                            <fn-base-input name="glbAssetsApiKey" [(ngModel)]="objectHash.glbAssetsApiKey"
                                                [dataKey]="'glbAssetsApiKey'" [type]="'text'"
                                                [fnInputValidator]></fn-base-input>
                                        </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="box-content">
              <h4 class="plumConnectorHeading">IDP Info</h4>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >Consumer Url</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="atsConsumerUrl"
                        [(ngModel)]="objectHash.atsConsumerUrl"
                        [dataKey]="'atsConsumerUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >Security IDP Url</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="idpUrl"
                        [(ngModel)]="objectHash.idpUrl"
                        [dataKey]="'idpUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="control-label text-left"
                    >Enable Login Via IDP</label
                  >
                </div>
                <div class="col-8">
                  <fn-switch
                    [(ngModel)]="objectHash.isIDPEnabled"
                    name="isIDPEnabled"
                  ></fn-switch>
                </div>
              </div>
            </div>
            <div class="box-content">
              <h4 class="plumConnectorHeading">Url Shortner Setup</h4>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >UrlShortner Url</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="urlShortnerSvcsUrl"
                        [(ngModel)]="objectHash.urlShortnerSvcsUrl"
                        [dataKey]="'urlShortnerSvcsUrl'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 wrapper_content">
                  <div class="row">
                    <div class="col-4">
                      <label class="control-label text-left"
                        >Url Shortner ApiKey</label
                      >
                    </div>
                    <div class="col-8">
                      <fn-base-input
                        name="urlShortnerSvcsApiKey"
                        [(ngModel)]="objectHash.urlShortnerSvcsApiKey"
                        [dataKey]="'urlShortnerSvcsApiKey'"
                        [type]="'text'"
                        [fnInputValidator]
                      ></fn-base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="control-label text-left"
                    >Enable Url Shortner</label
                  >
                </div>
                <div class="col-8">
                  <fn-switch
                    [(ngModel)]="objectHash.enableUrlShortnerSvcs"
                    name="enableUrlShortnerSvcs"
                  ></fn-switch>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="clearfix space-5"></div>
    <div class="col-8 offset-2">
      <div class="row">
        <div class="col-12 plumConnectorSetting">
          <div class="box-content">
            <h4 class="plumConnectorHeading">Idp User Info</h4>
            <div class="row">
              <div class="col-12">
                <div class="row mb-10">
                  <div class="col-6 mt-5 font-weight-600">Add Idp Users</div>
                  <div class="col-6 text-right P-0">
                    <fn-button
                      [type]="'info'"
                      btnClass="btn-sm btn-round"
                      [iconAddonBefore]="'global-add'"
                      [text]="'Add'"
                      (click)="addRow()"
                    ></fn-button>
                  </div>
                </div>
                <div class="clear hr margin-bottom-10"></div>
              </div>
              <div class="col-12">
                <fn-scrollbar style="max-height: 250px">
                  <table
                    class="table fixed-layout table-bordered table-stripped"
                  >
                    <colgroup>
                      <col width="35%" />
                      <col width="35%" />
                      <col width="30%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>Email</th>
                        <th>Role</th>
                        <th class="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let user of userArray; let i = index">
                        <td>
                          <fn-base-input
                            class="width-250px"
                            name="username"
                            [(ngModel)]="user.username"
                            [dataKey]="'username'"
                            [type]="'text'"
                            [fnInputValidator]
                            required
                          ></fn-base-input>
                        </td>
                        <td>
                          <fn-select
                            class="width-250px"
                            [labelKey]="'roleName'"
                            [inputKey]="'primaryKey'"
                            [(ngModel)]="user.role.primaryKey"
                            [optionList]="userRoleArray"
                            [placeholder]="'Select'"
                          >
                          </fn-select>
                        </td>
                        <td class="text-center">
                          <button
                            class="btn btn-sm btn-success fn-global-save"
                            (click)="saveUser(user)"
                          ></button>
                          <button
                            class="btn btn-sm btn-danger fn-global-delete ms-2"
                            (click)="deleteUser(i)"
                          ></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </fn-scrollbar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
